import { FormikValues } from 'formik'

import { Trade } from '../models'

export interface ManagedFund extends Trade {
  price: number
  quantity: number
  apir: string
  operation: string
  isinCode: string
  operationDate?: Date | string
  operationPrice?: number
}

export interface CreateManagedFundFormValues extends FormikValues {
  quantityToKeep: number
  price: number
  transactionDate: Date | string
  note?: string
  reference?: string
  bankReference?: string
}

export const createManagedFundInitialValues = {}
